import styled from '@emotion/styled';
import CalendarThemeBox from './CalendarThemeBox';

const CalendarThemeTableRow = styled(CalendarThemeBox)`
  display: table-row;
  width: 100%;
`;

export default CalendarThemeTableRow;
